/*
 * The application routing table.
 *
 *   require('path/to/file')       - Bundles the component into the main bundle.
 *   () => import('path/to/file')  - Creates a custom bundle for the component.
 */
export default [
    {
        isDefault: true,                                         // This is the default route.
        type: 'Route',                                           // The type of react-router-dom element to use: Route or Redirect.
        exact: false,                                            // The path must match exactly.
        path: ['/', '/sign-in/'],                                    // The window hash the application will exist under. (/#/hello/Smith)
        example: '/sign-in',                              // An example of how this route is used.
        description: 'Sign in application.',            // A description of what the route does.
        component: require('routes/signin'),                      // Require the component, importing it into the main bundle.
    },
    {
        type: 'Route',                                           // The type of react-router-dom element to use: Route or Redirect.
        exact: false,                                            // The path must match exactly.
        path: ['/sign-up/'],                                    // The window hash the application will exist under. (/#/hello/Smith)
        example: '/sign-up',                              // An example of how this route is used.
        description: 'Sign up application.',            // A description of what the route does.
        component: require('routes/signup'),                      // Require the component, importing it into the main bundle.
    },
];
